export const appsAppGroupIdChartsHasRevenue = "/apps/:app_group_id/charts/has_revenue";
